import { defineSettingsScreen } from '@heidi/runtime/shell';

/**
 * The `/settings/coding` screen body.
 *
 * `id` is the settings route slug (`ROUTE_TO_SLUG['/settings/coding']`), which
 * is what lets a package serve an existing settings screen with the sidebar and
 * the IA untouched: the loader resolves the route to this contribution and falls
 * back to the app's own importer for every route no package claims.
 *
 * `section: 'integrations'` is measured, not chosen — the screen renders
 * `group={t('settings.integrations')}` in its header and the sidebar lists
 * Coding under the Integrations group (`sidenav.settings.integrations`, the
 * label source `SETTINGS_SECTION_SIDEBAR_LABELS.integrations` records).
 *
 * `order: 0` inside the section's `[0, 999]` band. It is inert today — screens
 * are served by id and the sidebar is hand-written — so a low value claims no
 * position anyone else has to renumber around.
 *
 * `builds: 'all'`: measured, the screen exists on every build profile. Nothing
 * in the coding settings subtree reads the build profile or an Apple/on-prem
 * gate, `useSettingsList` renders the Coding item under the same clinical-coding
 * condition on every profile, and the on-prem shell would otherwise drop a
 * screen the appliance shows today.
 */
export const codingSettingsScreen = defineSettingsScreen({
  id: 'coding',
  section: 'integrations',
  order: 0,
  // The thunk names the export rather than relying on a default one: the screen
  // is a named export like every other component in this package, and
  // `ContributionLoadThunk` wants `{ default }`. The mapping is where the two
  // conventions meet, and it keeps the module free of a default export nothing
  // else would use.
  load: () =>
    import('../ui/settings/CodingSettings').then((module) => ({
      default: module.CodingSettings,
    })),
  builds: 'all',
});
